<div>
    <div *ngIf="data.exception.message; else olderrors">
        <h2 mat-dialog-title *ngIf="data.exception.message">{{ data.exception.message }}</h2>
        <mat-dialog-content *ngIf="data.exception">
            <div>Code: {{ data.exception.code }}</div>
            <div>File: {{ data.exception.file }}</div>
            <div>Line: {{ data.exception.line }}</div>
            <h2 mat-dialog-title>Stack:</h2>
            <pre>{{ data.backtrace | json }}</pre>
        </mat-dialog-content>
    </div>

    <ng-template #olderrors>
        <h2 mat-dialog-title>Detalhes do Erro:</h2>
        <mat-dialog-content>
            <h2 mat-dialog-title>Exception:</h2>
            <pre>{{ data.exception | json }}</pre>
            <h2 mat-dialog-title>Stack:</h2>
            <pre>{{ data.backtrace | json }}</pre>
        </mat-dialog-content>
    </ng-template>
    
    <mat-dialog-actions>
        <button mat-button (click)="close()">Fechar</button>
    </mat-dialog-actions>
</div>